// extracted by mini-css-extract-plugin
module.exports = {"container":"_4xww8B8ZeaAMWXBVg_NO1","closeIcon":"XRPUddRGO1XQgQdHEjv1x"};